import { Box, Paper, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import color from 'src/theme/color';
import { ReactComponent as GithubIcon } from 'src/assets/icons/github.svg';

export const CallbackContainer = styled(Box)(() => ({
    marginTop: 4
}));

export const CallbackPaper = styled(Paper)(() => ({
    padding: 3
}));

export const ContentBox = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '500px',
    width: '100%',
    textAlign: 'center',
    padding: '24px'
});

export const GithubIconStyled = styled(GithubIcon)({
    width: '70px',
    height: '70px',
    marginBottom: '20px'
});

export const LoadingText = styled(Typography)({
    marginTop: 2,
    color: color.white,
    fontWeight: 'medium',
    marginBottom: '24px'
});

export const LoadingDescription = styled(Typography)({
    color: color.white,
    opacity: 0.8,
    marginBottom: '32px',
    variant: 'body1'
});

export const SuccessDescription = styled(Typography)({
    color: color.white,
    opacity: 0.8,
    marginBottom: '24px',
    variant: 'body1'
});

export const ErrorText = styled(Typography)({
    color: color.white,
    marginBottom: '32px',
    variant: 'body1'
});

export const WaitingBox = styled(Box)({
    marginTop: '32px',
    display: 'flex',
    alignItems: 'center'
});

export const ButtonContentBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '100%',
    height: '100%'
});

export const ButtonTextBox = styled(Box)<{ $isHovered: boolean }>(
    ({ $isHovered }) => ({
        position: 'relative',
        transition: 'transform 0.3s ease-in-out',
        transform: $isHovered ? 'translateX(-8px)' : 'translateX(0)'
    })
);

export const ButtonIconBox = styled(Box)<{ $isHovered: boolean }>(
    ({ $isHovered }) => ({
        marginLeft: '8px',
        opacity: $isHovered ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        right: 'calc(50% - 75px)'
    })
);

export const IconBox = styled(Box)({
    marginTop: '16px',
    backgroundColor: color.blackLight2,
    width: '170px',
    height: '170px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    border: '1px solid transparent',
    transition: 'border-color 0.2s ease',
    '&:hover': {
        borderColor: color.yellowTransparent
    },
    '&.selected': {
        borderColor: color.yellow
    },
    borderRadius: '4px'
});

export const IconBoxContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
});

export const StyledButton = styled(Button)(({ theme }) => ({
    backgroundColor: color.yellow,
    width: '50%',
    color: color.white,
    fontWeight: 500,
    borderRadius: theme.spacing(3),
    textTransform: 'none',
    padding: theme.spacing(1.5),
    '&:hover': {
        color: color.yellow,
        backgroundColor: color.yellowTransparent
    }
}));
